/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Genre_FantasyInputs */

const en_onboarding_genre_fantasy = /** @type {(inputs: Onboarding_Genre_FantasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fantasy`)
};

const es_onboarding_genre_fantasy = /** @type {(inputs: Onboarding_Genre_FantasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fantasía`)
};

/**
* | output |
* | --- |
* | "Fantasy" |
*
* @param {Onboarding_Genre_FantasyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_genre_fantasy = /** @type {((inputs?: Onboarding_Genre_FantasyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Genre_FantasyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_genre_fantasy(inputs)
	return en_onboarding_genre_fantasy(inputs)
});